import { Box, Text } from '@cubeyou-team/hx-react-components';
import { PRODUCT_LINK } from '@discover-frontend/constants';
import classNames from 'classnames';
import React, { useMemo } from 'react';

import { ProductIcon } from '../product-icon';

export const ProductsDropdownContent = ({ products }) => {
  const getProductLink = (productSlug) => {
    return PRODUCT_LINK[process.env.REACT_APP_API_ENV][productSlug];
  };

  const productItems = useMemo(
    () =>
      products?.map((product) => (
        <div key={product.id}>
          <a
            href={`//${getProductLink(product.slug)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              className={classNames(
                'flex flex-col items-center justify-center',
                'rounded-md shadow-md',
                'cursor-pointer bg-hx-light-dark'
              )}
              style={{
                width: '132px',
                height: '132px',
              }}
            >
              <ProductIcon product={product} />
              <Text size="small" weight="bold" className="mt-2">
                {product.name}
              </Text>
            </div>
          </a>
        </div>
      )),
    [products]
  );

  return (
    <Box pY="medium" pX="medium">
      <div className="flex flex-wrap justify-center items-center gap-4 px-4 py-2 w-460">
        {productItems}
      </div>
    </Box>
  );
};
